import { generateUrlParams } from "../../utils/generateUrlParams";

const baseUrl = "Results";

export const getClassListUrl = (filter) =>
	`${baseUrl}/class-list?${generateUrlParams(filter)}`;
export const downloadClassListUrl = ({ departmentCourseId, sessionId }) =>
	`${baseUrl}/download-class-list?departmentCourseId=${departmentCourseId}&sessionId=${sessionId}`;
export const getResultsUrl = (filter) =>
	`${baseUrl}/course-grades?${generateUrlParams(filter)}`;
export const downloadScoreSheetUrl = ({ departmentCourseId, sessionId }) =>
	`${baseUrl}/download-score-sheet?departmentCourseId=${departmentCourseId}&sessionId=${sessionId}`;
export const downloadGSScoreSheet = ({ sessionId, courseId, semesterId }) =>
	`${baseUrl}/get-cbt-scoresheet?courseId=${courseId}&sessionId=${sessionId}&semesterId=${semesterId}`;
export const getGSCourses = ({ levelId, semesterId }) =>
	`${baseUrl}/gs-courses?LevelId=${levelId}&SemesterId=${semesterId}`;
export const getGSResultsUrl = (filter) =>
	`${baseUrl}/get-cbt-results?${generateUrlParams(filter)}`;
export const uploadGSScoreSheet = () => `${baseUrl}/upload-cbt-score-sheet`;
export const uploadScoreSheetUrl = ({ departmentCourseId }) =>
	`${baseUrl}/upload-result-score-sheet?departmentCourseId=${departmentCourseId}`;
export const getStudentCGPAsByIdUrl = (studentUserId) =>
	`${baseUrl}/student-semester-cgpa?studentUserId=${studentUserId}`;
export const getStudentCGPAsUrl = () => `${baseUrl}/student-semester-cgpa`;
export const getStudentSemesterResultUrl = (filter) =>
	`${baseUrl}/student-results?${generateUrlParams(filter)}`;
export const getGradeSheetUrl = ({ departmentCourseId, sessionId }) =>
	`${baseUrl}/download-grade-sheet?departmentCourseId=${departmentCourseId}&sessionId=${sessionId}`;
export const getCourseGradesUrl = (filter) =>
	`${baseUrl}/course-grades?${generateUrlParams(filter)}`;
export const studentCompositeResultsUrl = (filter) =>
	`${baseUrl}/students-composite-results?${generateUrlParams(filter)}`;
export const bulkDeanResultApprovalUrl = () => `${baseUrl}/bulk-dean-approval`;
